import { useQuery } from "@tanstack/react-query";
import client from "api/graphql/getClient";
import { graphql } from "gql/gql";
import { ListMsTeamsWebhooksParams } from "gql/graphql";
import { useActiveAccount } from "utils/useActiveAccount";
import useSnackbar from "utils/useSnackbar";

const listMsTeamsWebhooksDocument = graphql(/* GraphQL */ `
	query listMsTeamsWebhooks($params: ListMsTeamsWebhooksParams!) {
		listMsTeamsWebhooks(params: $params) {
			...msTeamsWebhookFields
		}
	}
`);

interface Args {
	params: ListMsTeamsWebhooksParams;
	userId?: string;
}

const listMsTeamsWebhooks = ({ userId, params }: Args) =>
	client(userId)
		.request(listMsTeamsWebhooksDocument, { params })
		.then((res) => res.listMsTeamsWebhooks);

const useListMsTeamsWebhooks = () => {
	const { userId, _id } = useActiveAccount();
	const { handleError } = useSnackbar();

	const params = {};

	return useQuery(
		["user", userId, "account", _id, "msTeamsWebhooks"],
		() => listMsTeamsWebhooks({ params, userId }),
		{
			enabled: !!userId,
			onError: (error) => handleError(error),
		}
	);
};

export default useListMsTeamsWebhooks;
